import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
    dark?: boolean;
}

const SlashIcon: React.FC<Props> = ({dark, ...props}) => {
    return (
        <svg width={10} height={26} viewBox="0 0 10 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M1 25L9 1" stroke="#EEE" className={dark ? 'white' : 'stroke-[#EEE]'} />
        </svg>
    );
};

export default SlashIcon;
